import { Phone } from "lucide-react";
import ContactForm from "@/components/ContactForm";

const FinalCTA = () => {
  return (
    <section className="py-20 md:py-28 bg-emerald-radial text-primary-foreground relative overflow-hidden">
      <div className="absolute inset-0 grid-emerald opacity-30" />
      <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] rounded-full bg-accent/15 blur-3xl" />
      <div className="page-container relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/15 border border-accent/30 text-accent text-xs font-semibold uppercase tracking-wider mb-4">
              Ready to dominate Culver City?
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold leading-tight">
              Let's see if we're the{" "}
              <span className="gold-gradient-text">right fit.</span>
            </h2>
            <p className="mt-5 text-lg text-primary-foreground/80">
              Tell us about your business. We'll come back within 24 hours with a custom Culver
              City SEO plan — and an honest answer on whether we can move the needle for you.
            </p>

            <div className="mt-8 space-y-4">
              <a
                href="tel:+13237841577"
                className="flex items-center gap-3 p-4 rounded-xl bg-background/10 border border-primary-foreground/15 backdrop-blur-sm hover:bg-background/20 transition-colors group"
              >
                <div className="w-10 h-10 rounded-lg bg-accent/20 flex items-center justify-center group-hover:bg-accent transition-colors">
                  <Phone className="w-5 h-5 text-accent group-hover:text-accent-foreground" />
                </div>
                <div>
                  <div className="text-xs text-primary-foreground/60 uppercase tracking-wider">
                    Prefer to talk?
                  </div>
                  <div className="font-bold text-lg">(323) 784-1577</div>
                </div>
              </a>

              <div className="text-sm text-primary-foreground/70 px-1">
                <div className="font-semibold text-primary-foreground mb-1">
                  Los Angeles SEO Services
                </div>
                10000 Washington Blvd, Culver City, CA 90232
              </div>
            </div>
          </div>

          <div className="bg-card text-card-foreground rounded-2xl p-7 md:p-8 shadow-2xl ring-gold">
            <h3 className="font-heading text-2xl font-bold mb-2">
              Get your free Culver City audit
            </h3>
            <p className="text-sm text-muted-foreground mb-6">
              Custom strategy delivered in 24 hours. No spam. No long contracts.
            </p>
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
